// import null from "../../assets/icons/eth.svg";
// import null from "../../assets/icons/polygon.png";

// mainnet chainIDs
// export const ACCEPTED_CHAIN_IDs = ["0x1", "0x89"];

// testnet chainIDs
export const ACCEPTED_CHAIN_IDs = ["0x13881"];

export const chainIdToNetworkInfo = {
  "0x89": {
    chainSymbol: "Polygon",
    blockExplorerUrl: "https://polygonscan.com",
    rpcUrl: "https://polygon-rpc.com",

    gasStation: "https://gasstation-mainnet.matic.network/v2",

    // configs to add chain in wallet
    configs: {
      chainId: "0x89",
      chainName: "Polygon Mainnet",
      nativeCurrency: {
        name: "MATIC",
        symbol: "MATIC",
        decimals: 18,
      },
      rpcUrls: ["https://polygon-rpc.com/"],
      blockExplorerUrls: ["https://polygonscan.com/"],
    },
    // deployed contract addresses
    contracts: {
      erc721Address: "",
      marketplaceAddress: "",
    },
  },
  "0x13881": {
    chainSymbol: "Mumbai",
    blockExplorerUrl: "https://mumbai.polygonscan.com",
    rpcUrl: "https://matic-mumbai.chainstacklabs.com",

    gasStation: "https://gasstation-mumbai.matic.today/v2",
    // configs to add chain in wallet
    configs: {
      chainId: "0x13881",
      chainName: "Mumbai",
      nativeCurrency: {
        name: "MATIC",
        symbol: "MATIC",
        decimals: 18,
      },
      rpcUrls: ["https://matic-mumbai.chainstacklabs.com"],
      blockExplorerUrls: ["https://mumbai.polygonscan.com/"],
    },
    // deployed contract addresses
    contracts: {
      erc721Address: "0x0a48BAe31130857De04c403a0E9877b653849765",
      marketplaceAddress: "0x8B535aD2b0Dd1E1e5D1073AAb37b5Bd1A24e2bf1",
    },
  },
};
